module.exports = __webpack_public_path__ + "static/media/cover-removal-of-debris.1ea3ea95.jpg";